import { render, staticRenderFns } from "./log_list.vue?vue&type=template&id=38a90e6e&scoped=true&"
import script from "./log_list.vue?vue&type=script&lang=js&"
export * from "./log_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a90e6e",
  null
  
)

export default component.exports